import { renderToString } from 'react-dom/server';

import LegendIcon from 'src/components/VacancyConversionChart/LegendIcon';

export const ICON_EDIT = renderToString(<LegendIcon type="edit" />);
export const ICON_ARROW_UP = renderToString(<LegendIcon type="prolongation" />);
